(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oakline-whatsapp"] && !Shopify.designMode) return;
  try {
    const whatsappLink = document.getElementById('oakline-whatsapp');
  if (whatsappLink) {
    let attempts = 0;
    const discoveryTimer = window.setInterval(() => {
      attempts += 1;
      const chatgramRoot = Array.from(document.querySelectorAll('div'))
        .map(element => element.shadowRoot)
        .find(root => root && root.querySelector('.cg-trigger'));
      if (chatgramRoot) {
        window.clearInterval(discoveryTimer);
        const positionStyle = document.createElement('style');
        positionStyle.textContent = '.cg-trigger { bottom: calc(88px + env(safe-area-inset-bottom, 0px)) !important; right: calc(20px + env(safe-area-inset-right, 0px)) !important; }';
        chatgramRoot.appendChild(positionStyle);
        const synchronizeChatgram = () => {
          const trigger = chatgramRoot.querySelector('.cg-trigger');
          whatsappLink.hidden = Boolean(trigger && trigger.classList.contains('cg-trigger--hidden'));
        };
        new MutationObserver(synchronizeChatgram).observe(chatgramRoot, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true
        });
        synchronizeChatgram();
      } else if (attempts >= 60) {
        window.clearInterval(discoveryTimer);
      }
    }, 500);
  }
  } catch(e) { console.error(e); }
})();

})();
